/* ============================================================
   HEMP LIFE - parallax backgrounds (Gravity XL)

   Drives [data-hl-parallax]. The inner .hl-life__bg is oversized
   by CSS; this shifts it against the scroll so the photograph
   drifts slower than the page.

   Why not background-attachment: fixed - it is broken on iOS
   Safari and repaints the whole layer every frame. This runs on
   the compositor via translate3d, only while the section is on
   screen, and stands down entirely for prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var items = [];
  var ticking = false;

  function measure(it) {
    var r = it.el.getBoundingClientRect();
    it.top = r.top + window.scrollY;
    it.h = r.height;
  }

  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    var y = window.scrollY;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.on || !it.bg) continue;
      // 0 as the section enters the viewport, 1 as it leaves
      var p = (y + vh - it.top) / (it.h + vh);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      // centre the travel so the image is neutral mid-section
      var shift = (p - 0.5) * 2 * it.depth;
      it.bg.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  function onResize() {
    for (var i = 0; i < items.length; i++) measure(items[i]);
    onScroll();
  }

  function init() {
    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq && mq.matches) return;

    var nodes = document.querySelectorAll('[data-hl-parallax]');
    if (!nodes.length) return;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var bg = el.querySelector('.hl-life__bg');
      if (!bg) continue;
      var depth = parseFloat(el.getAttribute('data-hl-parallax')) || 60;
      var it = { el: el, bg: bg, depth: depth, on: false, top: 0, h: 0 };
      measure(it);
      items.push(it);
    }
    if (!items.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          for (var k = 0; k < items.length; k++) {
            if (items[k].el === entries[j].target) items[k].on = entries[j].isIntersecting;
          }
        }
        onScroll();
      }, { rootMargin: '100px 0px' });
      for (var m = 0; m < items.length; m++) io.observe(items[m].el);
    } else {
      for (var n = 0; n < items.length; n++) items[n].on = true;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(onResize);
      for (var q = 0; q < items.length; q++) ro.observe(items[q].el);
    }
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // the theme editor rebuilds sections in place
  document.addEventListener('shopify:section:load', function () {
    items = [];
    init();
  });
})();
